import React from "react";
import * as c from "./contact-us.module.scss";
import classNames from "classnames";
import SEO from "@components/seo";
import { PageHeader } from "@components/pages/homepage/pageHeader";
import Layout from "@components/layout";
import { Button } from "@components/shared";
import StaticGradient from "@components/shared/staticGradient";
import IconMobileApp from "@components/icons/iconMobileApp";
import IconTwoWayTexting from "@components/icons/iconTwoWayTexting";

const contactBoxes = [
  {
    id: 0,
    icon: <IconTwoWayTexting />,
    title: "Chat with Us",
    description:
      "We’re here for you. No automatic answers or robots, promise! Start a chat to learn more about what Mangomint can do for you.",
    button: {
      label: "Start a chat",
      asHtmlButton: true,
      onClick: () => window?.drift && window.drift.api.openChat(),
    },
  },
  {
    id: 1,
    icon: <IconMobileApp />,
    title: "Get on a Call",
    description:
      "If you’d like to talk on the phone, you can schedule a demo call or give us your number and we'll call you back shortly.",
    button: {
      label: "Book a demo",
      linkTo: "/demo/",
    },
  },
];

export default function ContactUs() {
  return (
    <Layout className={c.container}>
      <StaticGradient opacity="0.45" top="-200px" mask="linear-gradient(to bottom, #000, transparent 50%)" />
      <SEO
        title="Contact Us"
        description="Contact Mangomint - No canned responses, no chatbots. Email, start a chat, or book a demo to see what Mangomint salon and spa software can do for you."
      />

      <PageHeader title="Contact us" className={c.header}>
        <h1 className="h1">Contact us</h1>
        <p className="p2">
          You can always email us at <a href="mailto:hello@mangomint.com">hello@mangomint.com</a>
        </p>
      </PageHeader>

      <section className={c.contactInfo}>
        <div className={c.boxes}>
          {contactBoxes.map(({ title, description, button, icon, id }) => (
            <div key={id} className={c.box}>
              <div className={c.icon}>{icon}</div>
              <h5 className={classNames("h5", c.title)}>{title}</h5>
              <p className={classNames("p3", c.description)}>{description}</p>
              <Button
                {...(button?.linkTo ? { linkTo: button.linkTo } : {})}
                {...(button?.asHtmlButton ? { asHtmlButton: button.asHtmlButton } : {})}
                onClick={button?.onClick}
              >
                {button.label}
              </Button>
            </div>
          ))}
        </div>
      </section>
    </Layout>
  );
}

export function Head() {
  return (
    <>
      <body className={c.body} />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "ContactPage",
            name: "Contact Us | Mangomint",
            url: "https://www.mangomint.com/",
            logo: "/images/mangomint-logo.png",
            description:
              "Mangomint is the highest rated scheduling software for hair salons, spas, nail salons, barbershops, tanning salons, massage studios, tattoo shops and more.",
            sameAs: ["https://www.youtube.com/@mangomint", "https://www.linkedin.com/company/mangomint"],
            contactPoint: {
              "@type": "ContactPoint",
              email: "hello@mangomint.com",
              contactType: "Customer Support",
            },
          }),
        }}
      />
    </>
  );
}
